import { SubmissionGroupEntityInterface } from '@types';
import { store } from '../store';

export const shouldUpdateGroups = (groupId: string, limit = 1) => {
  const submissionGroups: SubmissionGroupEntityInterface[] =
    store.getState()?.submissionGroup?.submissionGroups || [];
  return submissionGroups.find(({ id }) => id === groupId).submissions.length <= limit;
};
